import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { BodyTextM, cs, MuiImage } from "@repo/ui";
import FirstStepImage from "@repo/ui/assets/images/1st-step.png";
import { type FC } from "react";
import { Trans } from "react-i18next";
import Collapsible from "../../Collapsible";
import { InternalLink } from "../../Link";

const GDPR_URL = "https://www.nn.cz/ochrana-osobnich-udaju";

const AgreementContent: FC = () => {
	return (
		<Stack
			spacing={5}
			sx={{
				px: 4,
			}}
		>
			<Stack>
				<MuiImage
					sx={{
						margin: "auto"
					}}
					src={FirstStepImage}
				/>
			</Stack>
			<BodyTextM>{cs.firstLogin.preheader}</BodyTextM>
			<BodyTextM>{cs.firstLogin.intro}</BodyTextM>
			<Box>
				<Collapsible
					headline={cs.profile.communicationContractation.header}
				>
					<Stack spacing={4}>
						<BodyTextM>{cs.firstLogin.communicationContractationParagraph1}</BodyTextM>
						<BodyTextM>{cs.firstLogin.communicationContractationParagraph2}</BodyTextM>
						<BodyTextM>
							{cs.firstLogin.communicationContractationGdprPrefix}{" "}
							<InternalLink to={GDPR_URL} target="_blank" rel="noreferrer noopener">
								{cs.firstLogin.communicationContractationGdprLinkText}
							</InternalLink>
							.
						</BodyTextM>
					</Stack>
				</Collapsible>

				<Collapsible headline={cs.profile.personalInformation.header}>
					<BodyTextM>
						<Trans
							i18nKey="profile.personalInformation.content"
							components={{
								gdprLink: <InternalLink to={GDPR_URL} target="_blank" rel="noreferrer noopener" />,
							}}
						/>
					</BodyTextM>
				</Collapsible>
			</Box>
			<BodyTextM>{cs.firstLogin.accept}</BodyTextM>
		</Stack>
	);
};

export default AgreementContent;
